import Base from "./Base";
import store from "../storeWire";
import {
    setAddOpenQuote,
    SetClearAllQuote,
    setOpenQuoteEditBeforeToSendServer,
    setOpenQuoteList,
} from "../store/slice/model/OpenQuote";

class OpenQuote extends Base {
    setAddOpenQuote(data) {
        this.data = data;
        store.dispatch(setAddOpenQuote({
            data: this.data
        }));
    }
    setOpenQuoteEditBeforeToSendServer(data) {
        this.data = data;
        store.dispatch(setOpenQuoteEditBeforeToSendServer({
            data: this.data
        }));
    }
    

    setOpenQuoteList(data, rowObject = false) {
        this.data = data;
        let d = {
            openQuoteList: this.data
        };
        if (rowObject && rowObject.total !== undefined) {
            d.openQuoteListTotal = rowObject.total
        }
        store.dispatch(setOpenQuoteList(d));
    }
    setClearAllQuote() {
        store.dispatch(SetClearAllQuote());
    }

    setOpenQuoteListNew(lineItems) {
        store.dispatch(setOpenQuoteList(lineItems?.data?.quoteItems));
    }
  
}

export default OpenQuote;